import CrudList from "../components/CrudList";

const statusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "seasonal", label: "Seasonal" },
];

const FIELDS = [
  { name: "name", label: "Tour name", required: true, span: 2 },
  { name: "description", label: "Description", type: "textarea", span: 2 },
  { name: "duration_days", label: "Days", type: "number" },
  { name: "duration_hours", label: "Hours", type: "number" },
  { name: "price_per_person", label: "Price / person", type: "number" },
  { name: "price_per_group", label: "Price / group", type: "number" },
  { name: "max_capacity", label: "Max capacity", type: "number" },
  { name: "status", label: "Status", type: "select", options: statusOptions, default: "active" },
  { name: "locations", label: "Destinations", type: "tags", span: 2 },
  { name: "inclusions", label: "Inclusions", type: "textarea", span: 2 },
  { name: "exclusions", label: "Exclusions", type: "textarea", span: 2 },
  { name: "itinerary", label: "Itinerary", type: "textarea", span: 2 },
  { name: "image_url", label: "Image URL", span: 2 },
  { name: "notes", label: "Notes", type: "textarea", span: 2 },
];

const COLUMNS = [
  { key: "name", label: "Tour", render: (t) => <div><div className="font-heading">{t.name}</div><div className="text-xs text-muted-foreground">{Array.isArray(t.locations) ? t.locations.join(" · ") : ""}</div></div> },
  { key: "duration", label: "Duration", render: (t) => t.duration_days ? `${t.duration_days}d` : t.duration_hours ? `${t.duration_hours}h` : "—" },
  { key: "price_per_person", label: "Per person", render: (t) => t.price_per_person ? `$${t.price_per_person}` : "—" },
  { key: "max_capacity", label: "Capacity" },
  { key: "status", label: "Status", render: (t) => <span className="label-mono">{t.status}</span> },
];

export default function Tours() {
  return <CrudList endpoint="/tours" fields={FIELDS} columns={COLUMNS} testid="tours" emptyText="No tour packages yet." />;
}
